<div
  (click)="app.OCPost.openPost(post); app.routing.navigateOCPost(post._id)"
  class="card post-card pointer m-1 p-2"
  [ngClass]="{ 'selected-post': post === app.OCPost.selectedPost }"
  >
  <!-- Details -->
  <!-- First line -->
  <div class="d-flex flex-wrap align-items-center">
    @if (post.avatar != '') {
      <img
        class="profile-image-sm"
        target="_blank"
        [src]="app.file.getUrl(post.avatar)"
        />
    }
    @if (post.avatar === '') {
      <img
        class="profile-image-sm"
        target="_blank"
        [src]="app.url.profile.defaultImage"
        />
    }
    @if (!app.OCPost.postHasValidUserName(post)) {
      <span class="text m-1"
        ><b>{{ post.user_id }}</b></span
        >
      }
      @if (app.OCPost.postHasValidUserName(post)) {
        <span class="text m-1"
          ><b>{{ post.userFirstName }} {{ post.userLastName }}</b></span
          >
        }
        @for (badge of post.userBadges; track badge) {
          <div>
            <i
              class="fa-solid fa-medal fa-fw"
              [style.color]="app.OCHome.setBadgeColor(badge)"
              [ngbTooltip]="app.OCHome.setBadgeTooltip(badge)"
            ></i>
          </div>
        }
        <div
          class="credits tag p-1 ms-auto"
      [ngStyle]="
        app.OCPostItem.getTagColor(app.fieldId.ocPost.tagCategory, post.tag)
      "
          >
          {{ app.field.getOptionText(app.fieldId.ocPost.tagCategory, post.tag) }}
        </div>
      </div>
      <!-- Second line -->
      <div>
        <span class="text"
          ><b>{{ post.title }}</b></span
          >
        </div>
        <!-- 3th line -->
        <div
          class="text post-text"
          [innerHtml]="app.field.highlightLinks(post.message)"
          >
          {{ post.message }}
        </div>
        <!-- 4th line -->
        <div class="d-flex flex-wrap align-items-center">
          <!-- Commnets -->
          <div class="px-1">
            <i class="fa-regular fa-comment controls me-2"></i>
            <span class="controls-text">{{ post.counterComment }}</span>
          </div>
          <!-- Likes -->
          <div class="px-1">
            @if (!post.isLikedByLoggedInUser) {
              <i
                class="fa-regular fa-thumbs-up controls me-2"
              ></i>
            }
            @if (post.isLikedByLoggedInUser) {
              <i
                class="fa-solid fa-thumbs-up controls me-2 liked"
              ></i>
            }
            <span [ngClass]="{ liked: post.isLiked }" class="controls-text">
              {{ post.counterLikes }}
            </span>
          </div>
          <!-- Time info -->
          <div class="controls-text ms-auto">
            <span>Posted on {{ app.OCHome.getTimeInfo(post.create_time) }}</span>
            @if (post.update_time != post.create_time) {
              <span
                >&nbsp;Edited on {{ app.OCHome.getTimeInfo(post.update_time) }}</span
                >
              }
            </div>
          </div>
        </div>
